import React from "react";

const AuthNoticeModal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="auth-notice-backdrop" role="alertdialog" aria-modal="true">
      <div className="auth-notice-panel">
        <strong>입력 확인</strong>
        <p>{message}</p>
        <button type="button" onClick={onClose}>
          확인
        </button>
      </div>
    </div>
  );
};

export default AuthNoticeModal;
